import { render, staticRenderFns } from "./message-abstract-image.vue?vue&type=template&id=4ee73f6e&scoped=true"
import script from "./message-abstract-image.vue?vue&type=script&lang=ts"
export * from "./message-abstract-image.vue?vue&type=script&lang=ts"
import style0 from "./message-abstract-image.vue?vue&type=style&index=0&id=4ee73f6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee73f6e",
  null
  
)

export default component.exports